import styled from "styled-components";

import { NonDraggableImage } from "../common/styledComponents";

export const RouletteContainer = styled.div`
  flex-shrink: 0;
  z-index: 5;
  pointer-events: none;
`;

export const RotationContainer: any = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  transform: rotate(${(props: any) => props.startRotationDegrees}deg);

  &.started-spinning {
    animation:
      spin-${({ classKey }: any) => classKey}
        ${({ startSpinningTime }: any) => startSpinningTime / 1000}s
        cubic-bezier(
          0.71,
          ${(props: any) => (props.disableInitialAnimation ? 0 : -0.29)},
          0.96,
          0.9
        )
        0s 1 normal forwards running,
      continueSpin-${({ classKey }: any) => classKey}
        ${({ continueSpinningTime }: any) => continueSpinningTime / 1000}s linear
        ${({ startSpinningTime }: any) => startSpinningTime / 1000}s 1 normal forwards running,
      stopSpin-${({ classKey }: any) => classKey}
        ${({ stopSpinningTime }: any) => stopSpinningTime / 1000}s cubic-bezier(0, 0, 0.35, 1.02)
        ${({ startSpinningTime, continueSpinningTime }: any) =>
          (startSpinningTime + continueSpinningTime) / 1000}s
        1 normal forwards running;
  }

  @keyframes spin-${({ classKey }: any) => classKey} {
    from {
      transform: rotate(${(props: any) => props.startRotationDegrees}deg);
    }
    to {
      transform: rotate(${(props: any) => props.startRotationDegrees + 360}deg);
    }
  }
  @keyframes continueSpin-${({ classKey }: any) => classKey} {
    from {
      transform: rotate(${(props: any) => props.startRotationDegrees}deg);
    }
    to {
      transform: rotate(${(props: any) => props.startRotationDegrees + 360}deg);
    }
  }
  @keyframes stopSpin-${({ classKey }: any) => classKey} {
    from {
      transform: rotate(${(props: any) => props.startRotationDegrees}deg);
    }
    to {
      transform: rotate(${(props: any) => 1440 + props.finalRotationDegrees}deg);
    }
  }
`;

export const RoulettePointerImage = styled(NonDraggableImage)`
  position: absolute;
  z-index: 5;
  width: 17%;
  right: 16px;
  top: 35px;
`;
